import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { IPlotTemperatureRecord } from "@app/interfaces/IPlot";
import { ITemperatureProbe } from "@app/main/modules/temperature/_models/temperature/ITemperatureProbe";
import { ITemperatureProfile } from "@app/main/modules/temperature/_models/temperature/ITemperatureProfile";
import { TemperatureProbeService } from "@app/main/modules/temperature/_services/temperature-probe.service";
import { TemperatureProfileService } from "@app/main/modules/temperature/_services/temperature-profile.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { combineLatest, Subscription } from "rxjs";
import './temperatureRow.scss';

@UntilDestroy()
@Component({
    selector: 'temperature-row',
    template: require('./temperature-row.component.html')
})
export class TemperatureRowComponent implements OnChanges, OnDestroy {
    @Input() temperatureRecord: IPlotTemperatureRecord;
    @Input() showLabel: boolean;

    //--

    probe: ITemperatureProbe;
    profile: ITemperatureProfile;
    outOfBounds: boolean;

    dataSubscription = new Subscription();

    constructor(
        private readonly temperatureProbeService: TemperatureProbeService,
        private readonly temperatureProfileService: TemperatureProfileService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['temperatureRecord']) {
            this.getProbesAndProfiles();
        }
    }

    ngOnDestroy(): void {
        this.clearSubscriptions();
    }
    //--

    private getProbesAndProfiles(): void {
        this.clearSubscriptions();

        this.dataSubscription = combineLatest([
            this.temperatureProbeService.getTemperatureProbesForVehicle(this.temperatureRecord.VehicleId),
            this.temperatureProfileService.getTemperatureProfiles()
        ]).pipe(
                untilDestroyed(this)
        ).subscribe({
            next: ([probes, profiles]) => {
                this.probe = probes.find(probe => probe.Id == this.temperatureRecord.TemperatureProbeId);
                this.profile = profiles.find(profile => profile.Id == this.probe.TemperatureProfileId);
                this.setOutOfBounds();
            }
        });
    }

    private clearSubscriptions(): void {
        this.dataSubscription?.unsubscribe();
    }

    private setOutOfBounds(): void {
        if (!this.probe || !this.profile) {
            this.outOfBounds = false;
            return;
        }

        if (this.temperatureRecord.Temperature < this.profile.LowerBound ||
            this.temperatureRecord.Temperature > this.profile.UpperBound) {
            this.outOfBounds = true;
        }
    }
}
